var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDavMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.89655C23.5 7.29943 23.384 7.92275 23.1475 8.7416C22.9142 9.54971 22.5746 10.512 22.1523 11.5776C21.3081 13.7082 20.1435 16.2276 18.8678 18.7106C17.5919 21.1936 16.2097 23.631 14.9322 25.5988C14.2933 26.5829 13.6842 27.444 13.1308 28.1325C12.7057 28.6614 12.3254 29.0733 12 29.3599C11.6746 29.0733 11.2943 28.6614 10.8692 28.1325C10.3158 27.444 9.7067 26.5829 9.0678 25.5988C7.79029 23.631 6.40804 21.1936 5.13222 18.7106C3.85646 16.2276 2.69185 13.7082 1.84765 11.5776C1.42541 10.512 1.08577 9.54971 0.852441 8.7416C0.616008 7.92275 0.499995 7.29943 0.499995 6.89655C0.499995 5.24754 1.66729 3.65838 3.76385 2.45346C5.84681 1.25636 8.75765 0.5 12 0.5C15.2423 0.5 18.1532 1.25636 20.2361 2.45346C22.3327 3.65838 23.5 5.24754 23.5 6.89655Z",
    fill: "#C4C4C4",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5617 10.5C19.5617 14.9183 15.98 18.5 11.5617 18.5C7.14343 18.5 3.56171 14.9183 3.56171 10.5C3.56171 6.08172 7.14343 2.5 11.5617 2.5C15.98 2.5 19.5617 6.08172 19.5617 10.5Z",
    fill: "#F8F4F4",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0617 12.0353C12.0617 10.4887 13.0531 9.42857 14.0617 9.42857C15.0703 9.42857 16.0617 10.4887 16.0617 12.0353C16.0617 12.4177 15.998 12.6232 15.9336 12.7333C15.8791 12.8265 15.8049 12.8856 15.674 12.9284C15.5248 12.9772 15.32 12.9981 15.0317 12.9999C14.891 13.0007 14.7416 12.9973 14.5776 12.9933L14.5648 12.993C14.4068 12.9892 14.2366 12.9851 14.0617 12.9851C13.8868 12.9851 13.7166 12.9892 13.5586 12.993L13.5458 12.9933C13.3818 12.9973 13.2324 13.0007 13.0917 12.9999C12.8034 12.9981 12.5986 12.9772 12.4494 12.9284C12.3185 12.8856 12.2443 12.8265 12.1898 12.7333C12.1254 12.6232 12.0617 12.4177 12.0617 12.0353Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4903 7.21429C13.4903 6.81962 13.5912 6.48605 13.7281 6.26711C13.8693 6.04112 14.0004 6.00001 14.0617 6.00001C14.123 6.00001 14.2541 6.04112 14.3953 6.26711C14.5321 6.48605 14.6331 6.81962 14.6331 7.21429C14.6331 7.60896 14.5321 7.94254 14.3953 8.16148C14.2541 8.38746 14.123 8.42858 14.0617 8.42858C14.0004 8.42858 13.8693 8.38746 13.7281 8.16148C13.5912 7.94254 13.4903 7.60896 13.4903 7.21429Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06171 12.0353C7.06171 10.4887 8.0531 9.42857 9.06171 9.42857C10.0703 9.42857 11.0617 10.4887 11.0617 12.0353C11.0617 12.4177 10.998 12.6232 10.9336 12.7333C10.8791 12.8265 10.8049 12.8856 10.674 12.9284C10.5248 12.9772 10.32 12.9981 10.0317 12.9999C9.89101 13.0007 9.74164 12.9973 9.57759 12.9933L9.56481 12.993C9.40679 12.9892 9.23664 12.9851 9.06171 12.9851C8.88677 12.9851 8.71663 12.9892 8.5586 12.993L8.54582 12.9933C8.38178 12.9973 8.23241 13.0007 8.09172 12.9999C7.80343 12.9981 7.5986 12.9772 7.44938 12.9284C7.31847 12.8856 7.24431 12.8265 7.18979 12.7333C7.12541 12.6232 7.06171 12.4177 7.06171 12.0353Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49026 7.21429C8.49026 6.81962 8.59124 6.48605 8.72807 6.26711C8.86931 6.04112 9.00043 6.00001 9.06169 6.00001C9.12295 6.00001 9.25406 6.04112 9.3953 6.26711C9.53214 6.48605 9.63312 6.81962 9.63312 7.21429C9.63312 7.60896 9.53214 7.94254 9.3953 8.16148C9.25406 8.38746 9.12295 8.42858 9.06169 8.42858C9.00043 8.42858 8.86931 8.38746 8.72807 8.16148C8.59124 7.94254 8.49026 7.60896 8.49026 7.21429Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06171 12.0353C9.06171 10.3195 10.181 8.92857 11.5617 8.92857C12.9424 8.92857 14.0617 10.3195 14.0617 12.0353C14.0617 13.7511 12.9424 13.4851 11.5617 13.4851C10.181 13.4851 9.06171 13.7511 9.06171 12.0353Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56171 12.0353C9.56171 10.4887 10.5531 9.42857 11.5617 9.42857C12.5703 9.42857 13.5617 10.4887 13.5617 12.0353C13.5617 12.4177 13.498 12.6232 13.4336 12.7333C13.3791 12.8265 13.3049 12.8856 13.174 12.9284C13.0248 12.9772 12.82 12.9981 12.5317 12.9999C12.391 13.0007 12.2416 12.9973 12.0776 12.9933L12.0648 12.993C11.9068 12.9892 11.7366 12.9851 11.5617 12.9851C11.3868 12.9851 11.2166 12.9892 11.0586 12.993L11.0458 12.9933C10.8818 12.9973 10.7324 13.0007 10.5917 12.9999C10.3034 12.9981 10.0986 12.9772 9.94938 12.9284C9.81847 12.8856 9.74431 12.8265 9.68979 12.7333C9.62541 12.6232 9.56171 12.4177 9.56171 12.0353Z",
    stroke: "black",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5617,
    cy: 7.21429,
    rx: 1.07143,
    ry: 1.71429,
    transform: "rotate(-180 11.5617 7.21429)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9903 7.21429C10.9903 6.81962 11.0912 6.48605 11.2281 6.26711C11.3693 6.04112 11.5004 6.00001 11.5617 6.00001C11.623 6.00001 11.7541 6.04112 11.8953 6.26711C12.0321 6.48605 12.1331 6.81962 12.1331 7.21429C12.1331 7.60896 12.0321 7.94254 11.8953 8.16148C11.7541 8.38746 11.623 8.42858 11.5617 8.42858C11.5004 8.42858 11.3693 8.38746 11.2281 8.16148C11.0912 7.94254 10.9903 7.60896 10.9903 7.21429Z",
    stroke: "black",
    strokeOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_225",
    x: 2.56171,
    y: 5.50001,
    width: 18,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_225"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_225",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDavMarker);
export default __webpack_public_path__ + "static/media/Dav-marker.57c3d15f83baaf58c65c00ef3fa6bf93.svg";
export { ForwardRef as ReactComponent };